<template>
  <div>
    <slot />
    <div
      class="PageOverlay"
      :class="active ? 'show-Overlay' : ''"
      @click="setActiveClose"
    ></div>
    <div 
      class="drawerBox" 
      :style="{display:active?'':'none'}"
    >
      <div 
        v-if="drawerType=='default'" 
        class="drawerBox__default"
      >
        default
      </div>
      <div 
        v-else-if="drawerType=='select'" 
        class="drawerBox__select"
      >
        <div
          v-for="(subitem, subindex) in drawerData"
          :key="subindex"
          :value="subitem"
          class="select_item"
          @click="setSelectValue(subitem)"
        >
          <span style="float: left">{{ subitem }}</span>
          <span 
            class="iconfont icon-cm-duigou" 
            :style="{display:drawerValue[drawerIndex].value==subitem?'':'none'}"
          ></span>
        </div>
      </div>
      <div 
        v-if="drawerType=='object'" 
        class="drawerBox__object"
      >
        <div class="closeIcon ">
          <span class="iconfont icon-cm-cancel-1-copy" @click="setActiveClose"></span>
        </div>
        <div class="objectContent">
          <div class="objectContent__top">
            <div class="quick_left_img">
              <img
                class="sm_img"
                :src="(variantNew.feature_image &&
                        variantNew.feature_image.thumbnail) ||
                      (product.gallery && 
                        product.gallery.length && 
                        product.gallery[0].thumbnail) ||
                      defaultImage"
                @error.once="imageFailure($event,defaultImage)"
                alt
              />
            </div>
            <div class="quick_left_content">
              <h2
                class="page_text_font"
                @click="$('html,body').animate({ scrollTop: '0px' }, 300)"
              >
                {{ product.post_title }}
              </h2>
              <v-selectprice
                :price="price"
                :font-size="16"
                :regular-font-size="12"
                type="reverse"
                :regular_price_num="Number(regularPrice) > Number(price) ? regularPrice : ''"
                :disable_select="true"
                :appendToBody="false"
              ></v-selectprice>
            </div>
          </div>
          <div class="objectContent__bottom">
            <div
              class="product_variant"
              v-for="(item, index) in variantAttrs"
              :key="index"
            >
              <label 
                class="variant_label secondary_title" 
                :for="index" 
              >
                {{ item.name }}
              </label>
              <div class="variant_wrapper">
                  <el-button 
                    v-for="(subitem, subindex) in item.value" 
                    :key="subindex" 
                    :style="{backgroundColor:subitem==drawerValue[index].value?'#000':'',
                            color:subitem==drawerValue[index].value?'#fff':'',
                            borderColor:subitem==drawerValue[index].value?'#000':''}"
                    @click="setvariant(index,subitem)"
                  >
                    {{subitem}}
                  </el-button >
              </div>
            </div>
            <div 
              class="commoditynum secondary_title" 
            >
              <div 
                class="quantity-label secondary_title"
              >
                {{ $t("detail.quantity") }}
              </div>
              <my-el-input-number
                v-model="addproduct.quantity"
                :min="1"
                :max="100000"
                @keyup.enter.native="stock&&!loading && childMethod()"
                :step="1"
                step-strictly
              ></my-el-input-number>
            </div>
          </div>
        </div>
        <div class="addCartButton">
          <template v-if="stock">
            <div v-if="quickAddCart.button_type=='add_cart'">
              <el-button
                class="gocart sm_button main_button secondary_title"
                type="button"
                native-type="submit"
                :loading="loading"
                :disabled="!stock"
                @click="childMethod()"
                style="background: #000;
                      color: #fff;
                      margin: 5px;
                      display: inline-block;"
                :style="{ opacity: !stock ? '0.5' : '1' }"
              >
                {{ $t("detail.add_to_cart") }}
              </el-button>
            </div>
            <div v-else>
              <el-button
                class="buynow sm_button main_button secondary_title gocart"
                type="button"
                native-type="submit"
                :loading="loading"
                :disabled="!stock"
                @click="!loading && childMethod('buynow',true)"
                style="background: #000;
                      color: #fff;
                      margin: 5px;
                      display: inline-block; "
                :style="{ opacity: !stock ? '0.5' : '1' }"
              >
                {{ $t("detail.but_it_now") }}
              </el-button>
            </div>
          </template>
          <el-button
            v-else
            class="gocart soldout secondary_title"
            type="button"
            disabled
          >
            {{$t('detail.sold_out')}}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myElInputNumber from "@/js/components/myElement/myElInputNumber.vue"
export default {
  props:{
    active:{
      type:Boolean,
      require:true,
    },
    drawerType:{
      type:String,
      require:true,
    },
    drawerValue:{
      type:Array,
      require:false,
    },
    drawerIndex:{
      type:Number,
      require:false,
    },
    drawerData:{
      type:[Array,Object],
      require:false,
    },
    loading:{},
    stock:{},
    quickAddCart:{},
    variantNew:{},
    product:{},
    regularPrice:{},
    price:{},
    variantAttrs:{},
    addproduct:{},
  },
  data(){
    return{
    }
  },
  methods:{
    setSelectValue(data){
      let copydrawerValue = this.drawerValue
      copydrawerValue[this.drawerIndex].value = data
      this.$emit('update:drawerValue',copydrawerValue);
    },
    setActiveClose(){
      this.$emit('update:active',false)
    },
    childMethod(data,onlySelf){
      this.setActiveClose()
      this.$emit("fatherMethod",data,onlySelf);
    },
    setvariant(index,data){
      let copydrawerValue = this.drawerValue
      copydrawerValue[index].value = data
      this.$emit('update:drawerValue',copydrawerValue);
    }
  },
  watch:{
    active(val){
      if(val){
        this.$('body').css('height','100%')
        this.$('body').addClass('modal-open')
      }else{
        this.$('body').removeClass('modal-open')
      }
    }
  },
  components:{
    myElInputNumber
  }
}
</script>

<style lang="scss" scoped>
.show-Overlay {
  background-color: #000;
  opacity: 0.5;
  z-index: 1999999999 ;
  visibility: visible;
}
.gocart.soldout{
  border: 0 !important;
  background-color: #eeeeee !important;
  color: #999999 !important;
}
.drawerBox{
  display: flex;
  position: fixed;
  z-index: 1999999999 ;
  bottom: 0;
  left: 0;
  width: 100%;
  flex-direction: column;
  max-height: 70vh;
  overflow-y: auto;
  &__select{
    background-color: #fff;
    .select_item{
      display: flex;
      align-items: center;
      padding: 12px 24px;
      justify-content: space-between;
      width: 100%;
    }
  }
  &__object{
    max-height: 70vh;
    width: 100%;
    height: 70vh;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    .closeIcon{
      margin-top: 20px;
      height: 40px;
      .iconfont{
        border: 1.5px solid #fff;
        border-radius: 50%;
        padding: 5px;
        color: #fff;
        font-size: 15px;
        font-weight: 500;
      }
    }
    .objectContent{
      background-color: #fff !important;
      width: 100%;
      height: 100%;
      padding: 20px;
      overflow: scroll;
      &__top{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: flex-start;

        .quick_left_img{
          min-width: 90px;
          width: 90px;
          height: 90px;
          margin-right: 10px;
          position: relative;
          img{
            width: 100%;
            border-radius: 4px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            -o-object-fit: contain !important;
            object-fit: contain !important;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            transition: all 0.3s ease-in-out;
          }
        }
        .quick_left_content{
          h2{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 14px !important;
            font-weight: 500;
            color: #222222;
            line-height: 20px;
            margin-bottom: 10px;
          }
        }
      }
      &__bottom{
        .product_variant,.commoditynum{
          .variant_label,.quantity-label{
            font-weight: 600;
            margin-top: 12px;
            margin-bottom: 12px;
            text-transform:capitalize;
          }
          .variant_wrapper{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            .el-button{
              height: 44px;
              margin: 0 10px 10px 0 !important;
              border-radius: 0px !important;
              padding: 4px 20px !important;
              &::v-deep{
                span{
                  white-space: normal !important;
                  overflow: hidden;
                  line-height: 18px;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }
          }
        }
        .product_variant:nth-child(1){
          margin-top: 12px;
          border-top: 1px solid #eeeeee;
        }
        .commoditynum{
          .el-input-number{
            width: 132px !important;
            &::v-deep{
              .el-input-number__decrease,.el-input-number__increase {
                height: 42px !important;
                border-radius: 0px !important;
                background-color: #fff !important;
                i {
                  vertical-align: text-bottom !important;
                }
              }
              .el-input {
                &__inner {
                  height: 44px !important;
                  border-radius: 0px !important;
                  background-color: #ffffff !important;
                }
                &__inner:not(.is-disabled){
                  border-color: #DCDFE6 !important;
                }
              }
            }
          }
        }
      }
    }
    .addCartButton{
      width: 100%;
      .gocart{
        height: 44px !important;
        margin: 0 !important;
        width: 100%;
        border-radius: 0;
      }
      .buynow,.gocart{
        border-radius: 0px !important;
      }
    }
  }
}
</style>